import React, { useState, useEffect } from 'react';
import {useParams} from 'react-router-dom';
import ReactMarkdown from 'react-markdown';
import Prism from "prismjs";
import axios from "axios";

export const Post = (props)=>{

    const { id } = useParams();
    const [data, setData] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    useEffect(() => {
      setLoading(true);
      axios
        .get(`https://karlson.herokuapp.com/api/post/${id}`)
        .then((response) => {
          let data = JSON.stringify(response.data.data[0])
          setData(JSON.parse(data));
          console.log("Successfully fetched")
        })
        .catch((err) => {
          setError(err);
        })
        .finally(() => {
          setLoading(false);
          Prism.highlightAll();
        });
    }, []);
    if (loading) return <div className="loader"><span className="load"></span><span className="load"></span><span className="load"></span></div>;

    if (error) console.log(error);
    let mytitle = data.title || 'loading'
    let mycontent = data.content || 'loading.....'

    return (
        <div className="container text-start">
        <br/>
        <h1>{mytitle}</h1>
        <hr/>
        <ReactMarkdown source = {mycontent}>
        
        </ReactMarkdown>
        <br/>
        </div>
)}